import React from 'react';

// Mission creation now has 4 input steps once a template is selected:
// Motif, Période, Invitation, Confirmation. Step 0 is the template selection
// screen (no progress to display, hence the empty bar).
const Indicator = ({formIndex}) => {
    const totalSteps = 4;
    const currentStep = formIndex;

    const progressBar = {
        0: 'w-[0%]',
        1: 'w-[25%]',
        2: 'w-[50%]',
        3: 'w-[75%]',
        4: 'w-[100%]',
    }

    const label = currentStep === 0
        ? 'Sélection de la fiche de poste'
        : `Étape ${currentStep} sur ${totalSteps}`;

    return (
        <div className="flex items-center gap-4 flex-1 min-w-0">
            <div className="flex-1 min-w-0">
                <div className="mb-1.5">
                    <span className="text-sm font-medium text-gray-700">
                        {label}
                    </span>
                </div>
                <div className="h-2 w-full max-w-xs bg-gray-100 rounded-full overflow-hidden">
                    <div
                        className={`${progressBar[formIndex] || 'w-[0%]'} bg-gradient-to-r from-yellow-400 to-yellow-500 h-full rounded-full transition-all duration-300 ease-out`}
                    />
                </div>
            </div>
        </div>
    );
};

export default Indicator;
